import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import InstallGuide from "./components/InstallGuide";
import CacheGuide from "./components/CacheGuide";
import OfflineGuide from "./components/OfflineGuide";
import VersionSection from "./components/VersionSection";
import StorageGuide from "./components/StorageGuide";
import GenreSection from "./components/GenreSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <InstallGuide />
        <CacheGuide />
        <OfflineGuide />
        <VersionSection />
        <StorageGuide />
        <GenreSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}